import { compose, pick, values } from 'ramda'
import { useCallback, useEffect, useState } from 'react'

import {
  isChatPlaybook,
  isDraftEmailPlaybook,
  isFastLanePlaybook,
  isMarketplaceWebPlaybook,
  isMeetingBookingReportType,
  isOldEmailPlaybook,
} from 'utils/playbooks'

const useHideMenuOnScroll = (el, menu) => {
  const hideMenu = useCallback(() => {
    const $menu = document.querySelector(menu)

    if ($menu) {
      $menu.style.display = 'none'
    }
  }, [menu])

  useEffect(() => {
    const $el = document.querySelector(el)

    if ($el) {
      $el.addEventListener('scroll', hideMenu)
    }

    return () => {
      if ($el) {
        $el.removeEventListener('scroll', hideMenu)
      }
    }
  }, [el, hideMenu])
}

export const getPlaybookReportPath = (playbook = {}) => {
  const { id, reportType, status } = playbook

  const isChatPb = isChatPlaybook(reportType)
  const isMarketplaceWebPb = isMarketplaceWebPlaybook(reportType)
  const isDraftEmailPb = isDraftEmailPlaybook(reportType, status)
  const isOldEmailPb = isOldEmailPlaybook(reportType)
  const isMeetingBookingPb = isMeetingBookingReportType(reportType)

  if (isChatPb || isMeetingBookingPb) {
    return `/reports/playbooks/chat/${id}`
  }

  if (isMarketplaceWebPb || (!isDraftEmailPb && isOldEmailPb)) {
    return `/reports/playbooks/${id}`
  }

  if (isDraftEmailPb) {
    return `/playbooks/${id}/edit`
  }

  if (isFastLanePlaybook(playbook)) {
    return `/reports/playbooks/fastlane/${id}`
  }
}

export const openInNewTab = (event) => {
  const isMac = window.navigator.platform.includes('Mac')
  const isWin = !isMac
  return (isMac && event.metaKey) || (isWin && event.ctrlKey)
}

export function useContextMenu(el, menu) {
  const [origin, setOrigin] = useState({})

  useHideMenuOnScroll(el, menu)

  const setOriginPosition = useCallback(
    (event) => {
      if (event.target.closest(el)) {
        event.preventDefault()
        const $menu = document.querySelector(menu)

        if ($menu) {
          $menu.style.display = 'block'
        }

        setOrigin({ left: event.pageX, top: event.pageY })
      } else {
        setOrigin({})
      }
    },
    [el, menu, setOrigin]
  )

  useEffect(() => {
    window.addEventListener('contextmenu', setOriginPosition)

    return () => {
      window.removeEventListener('contextmenu', setOriginPosition)
    }
  }, [setOriginPosition])

  return origin
}

export const generateCacheKey = compose(
  values,
  pick([
    'category',
    'nameQuery',
    'page',
    'pageSize',
    'sortDirection',
    'sortProperty',
    'filterEnabled',
    'workspaceId',
  ])
)
